import { HTMLAttributes } from "react";
import { cva, cx, VariantProps } from "class-variance-authority";

const containerClasses = cva("tw-flex tw-gap-2 tw-gap-x-4 tw-flex-1 tw-h-full", {
    variants: {
        row: { true: "tw-flex-row", false: "tw-flex-col" }
    },
    defaultVariants: {
        row: false
    }
});

export const DataTableContainer = ({
                                       children,
                                       className,
                                       ...props
                                   }: HTMLAttributes<HTMLDivElement> & VariantProps<typeof containerClasses>) => {
    return (
        <div className={cx([containerClasses(props), className])} {...props}>
            {children}
        </div>
    );
};

export default DataTableContainer;